import { Chip, ChipOwnProps, Typography } from "@mui/material";
import { docStatusDictionary } from "@utils";
import { DocumentStatus } from "../../../../../types";

const docStatusDictionaryWithChanges: Record<
  keyof typeof docStatusDictionary | "CHANGES",
  { label: string; color: ChipOwnProps["color"] }
> = {
  ...docStatusDictionary,
  CHANGES: {
    label: "Changes",
    color: "error",
  },
};

const SelectableOption = ({
  label,
  type = DocumentStatus.ARCHIVED,
  showStatus = false,
  disabled = false,
}: {
  label: string;
  type?: keyof typeof docStatusDictionaryWithChanges;
  showStatus?: boolean;
  disabled?: boolean;
}) => {
  const chipLabel = docStatusDictionaryWithChanges[type].label;
  const chipColor = disabled
    ? "default"
    : docStatusDictionaryWithChanges[type].color || "default";

  return (
    <div
      className={`flex items-center gap-2 text-sm ${disabled ? "text-gray-400" : ""}`}
    >
      {showStatus && (
        <Chip
          label={chipLabel}
          variant="filled"
          color={chipColor}
          size="small"
        />
      )}
      <Typography
        variant="body1"
        color={disabled ? "textDisabled" : "textPrimary"}
      >
        {label}
      </Typography>
    </div>
  );
};

export default SelectableOption;
